import { CommonModule } from '@angular/common';
import {
    NgModule, Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input, Output,
    forwardRef, ContentChild, QueryList, Directive, EventEmitter,
} from '@angular/core';

@Component({
    selector: 'eui-expand-content',
    templateUrl: './eui-expand-content.component.html',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiExpandContentComponent {

    @HostBinding('class')
    get cssClasses() {
        return [
            `eui-expand-content`,
            this.isCollapsed ? 'eui-expand-content--collapsed' : '',
        ].join(' ').trim();
    }

    @Input() isCollapsed = false;
    @Input() expandLabel = '';
    @Input() collapseLabel = '';

    @Output() collapsed: EventEmitter<boolean> = new EventEmitter();

    constructor(
    ) {}

    onToggle() {
        this.isCollapsed = !this.isCollapsed;
        this.collapsed.emit(this.isCollapsed);
    }
}

/* ***************************************** */
/* MODULE EXPORT */
/* ***************************************** */
@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiExpandContentComponent,
    ],
    exports: [
        EuiExpandContentComponent,
    ],
})
export class EuiExpandContentModule { }
